module.exports = __webpack_public_path__ + "img/hr-straight-rail-diagonal-right-bottom-metals-remnants.c55f4857.png";